import React, { useState } from "react";

import { BankDetailsFragment, BankType, ParticipantTypes } from "@api/graphql";
import { DomesticBankDetailsAccordion } from "@components/account_profile/account_details/DomesticBankDetailsAccordion";
import { OverseasBankDetailsAccordion } from "@components/account_profile/account_details/OverseasBankDetailsAccordion";

interface BankDetailsAccordionProps {
  bankDetails: BankDetailsFragment;
  participantTypes: (ParticipantTypes | undefined)[];
  onUpdate: () => void;
}

const BankDetailsAccordion: React.FC<BankDetailsAccordionProps> = ({ bankDetails, participantTypes, onUpdate }) => {
  const [isEditbankDetails, setIsEditbankDetails] = useState(false);
  const [bankType, setBankType] = useState(bankDetails.bank_type);
  const shouldShow =
    participantTypes.includes(ParticipantTypes.ARTIST) ||
    participantTypes.includes(ParticipantTypes.ART_CENTRE) ||
    participantTypes.includes(ParticipantTypes.BENEFICIARY) ||
    participantTypes.includes(ParticipantTypes.AGENT) ||
    participantTypes.includes(ParticipantTypes.CMO);

  const onBankDetailsTypeChange = (type: BankType) => {
    setBankType(type);
  };

  if (!shouldShow) {
    return null;
  }

  return bankType === BankType.OVERSEAS ? (
    <OverseasBankDetailsAccordion
      bankDetails={bankDetails}
      onBankDetailsTypeChange={onBankDetailsTypeChange}
      setIsEditbankDetails={setIsEditbankDetails}
      isEditbankDetails={isEditbankDetails}
      onUpdate={onUpdate}
      participantTypes={participantTypes}
    />
  ) : (
    <DomesticBankDetailsAccordion
      bankDetails={bankDetails}
      onBankDetailsTypeChange={onBankDetailsTypeChange}
      setIsEditbankDetails={setIsEditbankDetails}
      isEditbankDetails={isEditbankDetails}
      onUpdate={onUpdate}
      participantTypes={participantTypes}
    />
  );
};

export default BankDetailsAccordion;
